var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButonCuContactNormalInchis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 83,
    viewBox: "0 0 77 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 31L39 14.8024L39 3.25567e-07",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30H54.9511H71.9022",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24.9023L39 49",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31L39 14.8024L39 3.25567e-07",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30H54.9511H71.9022",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24.9023L39 49",
    stroke: "black",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 46,
    x2: 30,
    y2: 46,
    stroke: "black",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 46,
    x2: 40,
    y2: 46,
    stroke: "black",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 46,
    x2: 9,
    y2: 46,
    stroke: "black",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 41,
    x2: 9,
    y2: 41,
    stroke: "black",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 51,
    x2: 9,
    y2: 51,
    stroke: "black",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 46,
    x2: 9,
    y2: 46,
    stroke: "black",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 52,
    x2: 1,
    y2: 41,
    stroke: "black",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 51,
    x2: 9,
    y2: 51,
    stroke: "black",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 46,
    x2: 9,
    y2: 46,
    stroke: "black",
    strokeWidth: 2
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 51,
    x2: 9,
    y2: 51,
    stroke: "black",
    strokeWidth: 2
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 46,
    x2: 9,
    y2: 46,
    stroke: "black",
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 51,
    x2: 9,
    y2: 51,
    stroke: "black",
    strokeWidth: 2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 46,
    x2: 9,
    y2: 46,
    stroke: "black",
    strokeWidth: 2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: -8.74229e-8,
    y1: 41,
    x2: 7,
    y2: 41,
    stroke: "black",
    strokeWidth: 2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 51,
    x2: 9,
    y2: 51,
    stroke: "black",
    strokeWidth: 2
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 46,
    x2: 9,
    y2: 46,
    stroke: "black",
    strokeWidth: 2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 51,
    x2: 9,
    y2: 51,
    stroke: "black",
    strokeWidth: 2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 46,
    x2: 9,
    y2: 46,
    stroke: "black",
    strokeWidth: 2
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 51,
    x2: 9,
    y2: 51,
    stroke: "black",
    strokeWidth: 2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 46,
    x2: 9,
    y2: 46,
    stroke: "black",
    strokeWidth: 2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 51,
    x2: 9,
    y2: 51,
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButonCuContactNormalInchis);
export default __webpack_public_path__ + "static/media/buton_cu_contact_normal_inchis.b4cba6be2d569b513d25deb715e057c0.svg";
export { ForwardRef as ReactComponent };